'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Circle = require('./shapes/Circle');

var _Circle2 = _interopRequireDefault(_Circle);

var _HalfCircle = require('./shapes/HalfCircle');

var _HalfCircle2 = _interopRequireDefault(_HalfCircle);

var _colors = require('./colors');

var _Tooltip = require('./Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Step = function (_Component) {
  _inherits(Step, _Component);

  function Step() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Step);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Step.__proto__ || Object.getPrototypeOf(Step)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (!_this.props.onClick) {
        return;
      }

      _this.props.onClick(_this.props.index, _this.props.name);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Step, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          activeColor = _props.activeColor,
          completed = _props.completed,
          onClick = _props.onClick,
          tip = _props.tip,
          tipDirection = _props.tipDirection,
          small = _props.small,
          partial = _props.partial,
          icon = _props.icon,
          children = _props.children,
          vertical = _props.vertical;
      var color = 'none';
      var outline = _colors.alloy;

      if (completed) {
        color = _colors.alloy;
      } else if (active) {
        color = activeColor;
        outline = partial ? _colors.alloy : color;
      }

      var indicatorIcon = _react2.default.createElement(_Circle2.default, {
        color: color,
        outline: outline,
        width: 13
      });

      if (icon) {
        indicatorIcon = icon;
      } else if (partial) {
        indicatorIcon = _react2.default.createElement(_HalfCircle2.default, {
          color: color,
          outline: outline,
          width: 13
        });
      }

      var stepperStyle = void 0;
      var indicatorStyle = void 0;
      var childrenStyle = void 0;

      if (vertical) {
        stepperStyle = {
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center'
        };
        childrenStyle = {
          padding: '7px 0',
          marginLeft: '10px',
          borderBottom: active ? '4px solid ' + color : '4px solid transparent',
          borderTop: '4px solid transparent'
        };
      } else {
        stepperStyle = {
          padding: small ? '0' : '0 14px',
          textAlign: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: children ? '0' : '14px'
        };
        childrenStyle = {
          padding: '14px 0',
          borderBottom: active ? '4px solid ' + color : ''
        };
      }

      var step = // TODO define stepper styles properly and move to stylesheet
      _react2.default.createElement('div', {
        className: 'stepper-step ' + (onClick ? 'clickable' : ''),
        style: stepperStyle,
        onClick: this.handleClick
      }, _react2.default.createElement('div', {
        style: indicatorStyle
      }, indicatorIcon), children && !small ? _react2.default.createElement('div', {
        style: childrenStyle
      }, children) : null);

      return tip ? _react2.default.createElement(_Tooltip2.default, {
        direction: tipDirection,
        contents: tip
      }, step) : step;
    }
  }]);

  return Step;
}(_react.Component);

exports.default = Step;
Step.propTypes = {
  index: _propTypes2.default.number,
  active: _propTypes2.default.bool,
  partial: _propTypes2.default.bool,
  activeColor: _propTypes2.default.string,
  completed: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  name: _propTypes2.default.string,
  tip: _propTypes2.default.node,
  tipDirection: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  children: _propTypes2.default.node,
  small: _propTypes2.default.bool,
  icon: _propTypes2.default.node,
  vertical: _propTypes2.default.bool
};
Step.defaultProps = {
  tipDirection: 'top'
};